export const ComparisonBar = ({ label, value, highlight, tone }) => (
  <div className="flex items-center gap-3">
    <span
      className={`w-24 shrink-0 truncate text-sm sm:w-28 ${highlight ? "font-semibold" : "text-muted-foreground"}`}
      title={label}
    >
      {label}
    </span>
    <div className="h-3 flex-1 overflow-hidden rounded-full bg-secondary">
      <div
        className="h-full rounded-full transition-all"
        style={{ width: `${value}%`, background: highlight ? tone.bar : "hsl(215,16%,68%)" }}
      />
    </div>
    <span className={`w-8 shrink-0 text-right text-sm tabular-nums ${highlight ? "font-semibold" : "text-muted-foreground"}`}>
      {value}
    </span>
  </div>
);
